import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from './authenticationModule/services/authentication.service';
import {UtilsService} from './appSharedModule/services/utils.service';
import {MessageService} from 'primeng/api';
import {ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, NavigationStart, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {MfaComponent} from './components/mfa/mfa.component';
import {filter} from 'rxjs';
import {map} from 'rxjs/operators';
import {PRIVACY_POLICY_URL} from './constants/app.constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [MessageService]
})
export class AppComponent implements OnInit {
  private keepMessagesAfterRouteChange = false;

  @ViewChild('sectionNeedToScroll') sectionNeedToScroll: ElementRef;
  @ViewChild(MfaComponent) mfaComponent!: MfaComponent;
  public breadcrumbs: any[] = [];
  year = new Date();
  privacyPolicyUrl = PRIVACY_POLICY_URL;

  constructor(
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService,
    public messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private titleService: Title
  ) {
    authenticationService.authenticationEvents$.subscribe();

    this.subscribeForMessagesFromUtilsService();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepMessagesAfterRouteChange) {
          this.keepMessagesAfterRouteChange = false;
        } else {
          this.messageService.clear();
        }
      }

      if ((event instanceof NavigationEnd)) {
        if (this.sectionNeedToScroll) {
          this.sectionNeedToScroll.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'});
        }

        this.breadcrumbs = this.makeBreadCrumb(this.router.routerState.snapshot.root);

        let breadcrumbForTitle = '';
        for (const breadcrumb of this.breadcrumbs) {
          breadcrumbForTitle += ' > ' + breadcrumb.title;
        }
      }
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute.firstChild;
          while (route?.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route?.snapshot?.data != null),
      )
      .subscribe((route) => {
        const tabTitle = route.snapshot.data['tabTitle'] || '';
        this.titleService.setTitle(`McKay Portal – ${tabTitle}`);
      });
  }

  private subscribeForMessagesFromUtilsService() {
    this.utilsService.messagesForToasts$.subscribe(
      msg => {
        this.messageService.add(msg);
        if (msg.keepMessagesAfterRouteChange) {
          this.keepMessagesAfterRouteChange = true;
        }
      },
    );
  }

  ngOnInit(): void {
    this.addTestMessages();

  }

  addTestMessages() {
    this.messageService.add({
      severity: 'error',
      summary: 'Summary Text',
      detail: 'Detail Text',
      sticky: true,
      closable: true
    });
    this.messageService.add({severity: 'success', summary: 'Service Message', detail: 'Via MessageService'});
  }

  closeAll() {
    this.messageService.clear();
    this.keepMessagesAfterRouteChange = false;
  }

  private makeBreadCrumb(route: ActivatedRouteSnapshot) {
    let breadcrumb = [];
    if (!route) {
      return breadcrumb;
    }
    if (route.data.title && route.url && route.url.length) {
      let fullUrl = '';
      for (const urlSegment of route.url) {
        fullUrl += '/' + urlSegment.path;
      }
      breadcrumb.push({
        url: fullUrl,
        title: (route.data && route.data.title ? route.data.title : 'Home?'),
        isLast: (!route.firstChild),
      });
    }
    const subBreadcrumb = this.makeBreadCrumb(route.firstChild);
    breadcrumb = breadcrumb.concat(subBreadcrumb);
    return breadcrumb;
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  isResetPasswordPage() {
    for (const param of location.href.split('/')) {
      if (param === 'reset-password') {
        return true;
      }
    }
    return false;
  }

  isNewUserConfirmationPage() {
    for (const param of location.href.split('/')) {
      if (param === 'new-user-confirmation') {
        return true;
      }
    }
    return false;
  }

  isNewEmailConfirmationPage() {
    for (const param of location.href.split('/')) {
      if (param === 'email-confirmation') {
        return true;
      }
    }
    return false;
  }

  isMfa() {
    if (!this.getUserCurrent()) {
      return false;
    }
    return this.getUserCurrent().permissions.incompleteLogin && this.utilsService.getCookie('mfa') === '1';
  }

  mfaSetup() {
    if (!this.getUserCurrent()) {
      return false;
    }
    return this.getUserCurrent().permissions.mustSetupAuthenticator && this.utilsService.getCookie('setup') === '1';
  }

  onDialogShow() {
    setTimeout(() => {
      if (this.mfaComponent) {
        this.mfaComponent.focusCodeInput(0);
      }
    });
  }

  navigateToCartFromToast(messageId?: string) {
    this.router.navigate(['/cart']);
    if (messageId) {
      this.messageService.clear(messageId as string);
    } else {
      this.messageService.clear();
    }
  }

}
